<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator" *ngIf="bankAccount.id == null">Nueva Cuenta de Banco</h3>
            <h3 class="m-subheader__title m-subheader__title--separator" *ngIf="bankAccount.id != null">Editar Cuenta de Banco</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/categories'" class="m-nav__link">
                        <span class="m-nav__link-text">Cuentas de Bancos</span>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a *ngIf="bankAccount.id == null" [routerLink]="'/bank-accounts/create'" class="m-nav__link">
                        <span class="m-nav__link-text">Crear Cuenta de Banco</span>
                    </a>
                    <a *ngIf="bankAccount.id != null" [routerLink]="['/bank-accounts/edit', bankAccount.id]" class="m-nav__link">
                        <span class="m-nav__link-text">Editar Cuenta de Banco</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 *ngIf="bankAccount.id == null" class="m-portlet__head-text">
                                Crear Cuenta de Banco
                            </h3>
                            <h3 *ngIf="bankAccount.id != null" class="m-portlet__head-text">
                                Editar Cuenta de Banco - {{bankAccount.bank_name}}
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <a [routerLink]="'/bank-accounts'"
                                   class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle">
                                    <i class="flaticon-reply"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <form [formGroup]="form" (ngSubmit)="sendForm()" class="m-form m-form--label-align-right">
                    <div class="m-portlet__body">
                        <div class="m-form__section m-form__section--first">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Nombre de Banco:</label>
                                <div class="col-lg-6">
                                    <input formControlName="bank_name" class="form-control m-input" placeholder="Nombre de Banco"
                                           [ngClass]="{ 'is-invalid': submitted && f.bank_name.errors }">
                                    <div *ngIf="submitted && f.bank_name.errors" class="invalid-feedback">
                                        <div *ngIf="f.bank_name.errors.required">Nombre de banco obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Número de Cuenta:</label>
                                <div class="col-lg-6">
                                    <input formControlName="bank_account_number" class="form-control m-input" placeholder="Número de Cuenta"
                                           [ngClass]="{ 'is-invalid': submitted && f.bank_account_number.errors }">
                                    <div *ngIf="submitted && f.bank_account_number.errors" class="invalid-feedback">
                                        <div *ngIf="f.bank_account_number.errors.required">Número de cuenta obligatorio</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot m-portlet__foot--fit">
                        <div class="m-form__actions">
                            <div class="row">
                                <div class="col-2">
                                </div>
                                <div class="col-7">
                                    <button type="submit" [disabled]="loading"
                                            class="btn btn-accent m-btn m-btn--air m-btn--custom"
                                            [ngClass]="{'m-loader m-loader--light m-loader--right': loading}">
                                        Guardar Cambios
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
